// extracted by mini-css-extract-plugin
export var cell = "_5u-4";
export var headerCell = "_5u-2";
export var rowHeader = "_5u-3";
export var table = "_5u-1";
export var tableContainer = "_5u-0";